import React from 'react';

import { Button, Main, Info, Content } from "./styled";











function SubscriptionSection({
  title,
  subtitle,
  buttonText,
  children,
  onButtonClick,
  className,
  hasButton })
{
  return /*#__PURE__*/(
    React.createElement(Main, { className: className }, /*#__PURE__*/
    React.createElement(Info, null, /*#__PURE__*/
    React.createElement("span", null, title), /*#__PURE__*/
    React.createElement("span", null, subtitle)), /*#__PURE__*/


    React.createElement(Content, null, children),

    hasButton && /*#__PURE__*/
    React.createElement(Button, { size: "small", onClick: onButtonClick },
    buttonText)));




}

export { SubscriptionSection };